module.exports = __webpack_public_path__ + "static/sport/bannercenter.1ff3335.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/bannercenter.png
// module id = 4U9v
// module chunks = 0